module.exports = __webpack_public_path__ + "static/media/phone-number-input.8328e94f.svg";